module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "level app-levelbar"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('h3', {
    staticClass: "subtitle is-5"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))])])]), _vm._v(" "), (!!_vm.codelink) ? _c('div', {
    staticClass: "level-item"
  }, [_c('tooltip', {
    attrs: {
      "label": "View code",
      "placement": "right",
      "size": "small",
      "rounded": true
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('a', {
    attrs: {
      "href": _vm.codelink
    }
  }, [_c('i', {
    staticClass: "fab fa-github"
  })])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "level-right is-hidden-mobile"
  }, [_c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  })], 1)])
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9d53ce0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"_CLIENT_ID_PLACE_HOLDER_","replace":"lfms21abk334e3i1lnkpr70ep"},{"search":"_BASE_API_PLACE_HOLDER_","replace":"https:/homeiottf-dev.auth.ap-northeast-2.amazoncognito.com"},{"search":"_CALLBACK_URL_HOLDER_","replace":"https:/www.homeiottf.com"}]}!./client/components/layout/Levelbar.vue